// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { FiltersContext } from 'Contexts/FiltersContext';

export default function useFilters() {
  return useContext(FiltersContext);
}
